/* @flow */

import { borderRadius } from 'src/shared/app/base/style/token/box';
import { cardBaseColor } from '@e180/ui/lib/token/color';
import { disabledOpacity } from 'src/shared/app/base/style/token/opacity';

export default {
  root: {
    width: '100%',

    backgroundColor: cardBaseColor,
    borderRadius,
  },
  'root-isFaded': {
    opacity: disabledOpacity,
  },
  'root-isDisabled': {
    opacity: disabledOpacity,

    pointerEvents: 'none',
  },
};
